import { CART_UPDATE } from '../../../shared/constants/api';
import * as api from '../../../shared/services/apiClient';
import { CartView, CartGroupView, CTLineItem } from '../types/cartTypes';
import { getCart, emitCartUpdate } from '../utils/cartUtil';


function getAssociationKey(contextItem: CartGroupView | CTLineItem): string | undefined {
  if ('mainItem' in contextItem) {
    return contextItem.mainItem.custom?.fields?.['associationKey'];
  }
  return contextItem.custom?.fields?.['associationKey'];
}

export async function updateQuantity(
  contextItem: CartGroupView | CTLineItem,
  newQuantity: number,
  existingCart: CartView | null = null
): Promise<CartView | null> {
  if (!newQuantity || newQuantity < 0) {
    throw new Error('Invalid quantity: must be a positive number');
  }

  const associationKey = getAssociationKey(contextItem);
  if (!associationKey) {
    throw new Error('No association key found for item');
  }

  const cart = existingCart ?? (await getCart());
  if (!cart) throw new Error('No cart available');

  const res = await api.post(CART_UPDATE, {
    cartId: cart.id,
    associationKey,
    quantity: newQuantity,
  });

  if (!res.ok) {
    throw new Error(`Failed to update cart: ${res.status}`);
  }

  const updatedCart = (await res.json()) as CartView;
  emitCartUpdate(updatedCart);
  return updatedCart;
}
